import { FieldProps } from '~components/form-fields';

import { getAll as getUsers } from '~care-workers/actions';

import { selectLookupUsers } from '~care-workers/selectors/users';

interface OverviewPlanDetailsOptions {
  isReviewDueSoon: boolean;
}

// Plan Details form for the care plan Overview tab. Read-only rows (type,
// MAC/NDIS number, next review due) render through the same FormFields layout
// as the editable fields (start date, end date, care partner) so the section
// shares the app-standard form UX. The review-due row carries the amber
// highlight class while the date falls within REVIEW_DUE_SOON_DAYS.
export const overviewPlanDetailsFields = ({ isReviewDueSoon }: OverviewPlanDetailsOptions): FieldProps => ({
  plan_type_label: {
    type: 'readonly',
    caption: 'Care plan type',
    dataCy: 'care-plan-type',
  },
  identity_number: {
    type: 'readonly',
    caption: 'MAC / NDIS number',
    dataCy: 'care-plan-identity-number',
  },
  start_date: {
    type: 'date',
    caption: 'Start date',
    required: true,
    // Same colSize as end_date + care partner so the editable inputs align to one width.
    colSize: 4,
    dataCy: 'care-plan-start-date',
  },
  end_date: {
    type: 'date',
    caption: 'End date',
    colSize: 4,
    dataCy: 'care-plan-end-date',
  },
  review_due_date: {
    type: 'readonly',
    caption: 'Next review due',
    className: isReviewDueSoon ? 'care-plan-review-due-soon' : undefined,
    dataCy: 'care-plan-review-due',
  },
  carer_id: {
    type: 'select',
    caption: 'Care partner',
    // Same colSize as start_date / end_date so the editable inputs align to one width.
    colSize: 4,
    selectorOptions: selectLookupUsers,
    selectorActions: getUsers,
    placeholder: '-- Select a care partner --',
    dataCy: 'care-plan-care-partner',
  },
});
